"use client";

import { usePathname } from "next/navigation";

/**
 * Everywhere except the homepage this renders the existing solid sticky bar.
 * On "/" the header is transparent and absolutely positioned over the top of
 * the hero — no background block, part of the hero — and scrolls away with
 * the page (absolute, not sticky/fixed). The hero's light background keeps
 * the default dark logo/nav text legible.
 */
const HeaderFrame = ({ children }: { children: React.ReactNode }) => {
  const isHome = usePathname() === "/";

  if (!isHome) {
    return (
      <header className="w-full border-b sticky top-0 z-50 bg-background">
        {children}
      </header>
    );
  }

  return (
    <header className="w-full absolute top-0 inset-x-0 z-50 bg-transparent">
      {children}
    </header>
  );
};

export default HeaderFrame;
